import React from "react";
import "../../styles/footer.css"

function Quote() {
  return (
    <div className="worlds">
      <div className="wordls-conatainer">
        <p className="phrase">
          <span>“</span>Have the courage to follow your heart and intuition.
          <br /> They somehow already know what you truly want to become. 
          <br />Everything else is secondary.<span>”</span>
        </p>
      </div>
      <p className="quote-author">— Steve Jobs</p>
    </div>
  )
}

export default Quote;